import { Box, Typography } from '@mui/material';

type ContentSize = 'lg' | 'md' | 'sm';

type ContentCardProps = {
  leftComponent?: JSX.Element;
  title: string;
  size?: ContentSize;
  description?: string;
  label?: string;
  labelProps?: {
    color: string;
    backgroundColor: string;
  };
};

export const ContentCard = ({
  leftComponent,
  title,
  size = 'md',
  description,
  label,
  labelProps,
}: ContentCardProps) => {
  const labelComponent = label && (
    <Typography
      fontSize={'14px'}
      fontWeight={'400'}
      lineHeight={'17px'}
      color={labelProps?.color}
      sx={{
        padding: '8px',
        textAlign: 'center',
        borderRadius: '3px',
        backgroundColor: labelProps?.backgroundColor || '#F4F2F4',
      }}
    >
      {label}
    </Typography>
  );

  const titleSize = {
    lg: {
      fontWeight: '600',
      fontSize: '20px',
      lineHeight: '32px',
    },
    md: {
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '32px',
    },
    sm: {
      fontSize: '14px',
    },
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        {leftComponent}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              color: '#091E42',
              ...titleSize[size],
            }}
          >
            {title}
          </Typography>
          {!!description && (
            <Typography
              sx={{
                color: '#655C68',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '24px',
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
      </Box>

      {labelComponent}
    </Box>
  );
};
